import React from 'react';
import PropTypes from 'prop-types';
import {
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonTitle,
  IonButtons,
  IonToolbar,
  IonList,
  IonItem,
  IonLabel,
} from '@ionic/react';
import moment from 'moment';
import capitalize from 'lodash/capitalize';

const dayOrder = {
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6,
  sun: 7,
};

function compareDays(a, b) {
  return dayOrder[a] - dayOrder[b];
}

function PromotionModal({ open, onClose, promotion }) {
  return (
    <IonModal isOpen={open} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{promotion?.name}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose} fill="light">
              Close
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList className="ion-padding">
          <IonItem lines="none">
            <IonLabel>
              <div>
                Available Days:
                <div>{promotion?.availableDays.sort(compareDays).map(d => capitalize(d)).join(", ")}</div>
              </div>
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              Start:{' '}
              {promotion?.start
                ? moment(promotion?.start, 'x').format('MM/DD/YYYY hh:mm A')
                : '-'}
            </IonLabel>
          </IonItem>
          <IonItem lines="none">
            <IonLabel>
              End:{' '}
              {promotion?.end
                ? moment(promotion?.end, 'x').format('MM/DD/YYYY hh:mm A')
                : '-'}
            </IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonModal>
  );
}

PromotionModal.propTypes = {
  promotion: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PromotionModal;
